import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Dialog/Dialog.Front.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DialogFront = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    className: clsx("pd:dialog__front", className)
  }, rest), {
    children
  }));
};
var Dialog_Front_default = DialogFront;
export { Dialog_Front_default };